





















































import { Watch, Prop, Component, Vue } from 'vue-property-decorator'
import { Branch } from '@/api/model/branch'
import { BranchTarget } from '@/api/model/branch-target'
import { BranchTargetAPI } from '@/api/backend-client'
import ListTargetsActions from '@/views/Company/Settings/Teams/Edit/ListTargetsActions.vue'

@Component({
    components: {ListTargetsActions},
})
export default class ListTargets extends Vue {
    @Prop({ required: true }) readonly team: Branch|null
    loading: boolean = false
    targets: BranchTarget[] = []

    created() {
        this.onTeamChange()
    }

    @Watch('team')
    async onTeamChange(): Promise<void> {
        await this.reloadTargets()
    }

    goToTargetsCreate(): void {
        this.$emit('create')
    }

    goToTargetEdit(target: BranchTarget): void {
        this.$emit('edit', target)
    }

    async deleteTarget(target: BranchTarget): Promise<void> {
        if (confirm(this.$t('company_settings.targets.delete_confirm').toString())) {
            await BranchTargetAPI.delete(target.id)
            await this.reloadTargets()
        }
    }

    async reloadTargets(): Promise<void> {
        this.targets = []

        if (this.team) {
            this.loading = true
            this.targets = await BranchTargetAPI.getAll()
            this.loading = false
        }
    }

    get filteredTargets(): BranchTarget[] {
        return this.targets
            .filter(target => target.branch.id === this.team.id)
    }
}
